export default __webpack_public_path__ + "static/media/wallet-connect.1a1e5f36.png";